import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  emailVerificationFailureTitle: {
    id: "funding-application: email verification failure title",
    defaultMessage: "Sorry, an error occured during email verification.",
  },
  emailVerificationTroubleTitle: {
    id: "funding-application: email verification trouble title",
    defaultMessage: "Trouble receiving verification email?",
  },
  emailVerificationStepTitle: {
    id: "funding-application: email verification title",
    defaultMessage: "Email not verified",
  },
  emailVerificationStepButtonReSend: {
    id: "funding-application: email verification button re-send",
    defaultMessage: "Re-send verification email",
  },
  emailVerificationStepButtonSent: {
    id: "funding-application: email verification button sent",
    defaultMessage: "Sent",
  },
});
